import BaseIcon from "./base"

/**
 * Icon TbRouteAltRight from 'react-icons/tb'.
 */
export default function RouteRightIcon({size = 24}) {
    return (
        <BaseIcon size={size}>
            <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="M16 3h5v5"></path><path d="M8 3h-5v5"></path><path d="M21 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"></path><path d="M6 6.01v-.01"></path><path d="M8 8.02v-.01"></path><path d="M10 10v.01"></path></svg>
        </BaseIcon>
    )
}
